export default __webpack_public_path__ + "images/painters.2ade30cd9035d1c78fa4fdf9da67b306.svg";